module.exports = __webpack_public_path__ + "img/CM-SS-25-Volkswagen-Playful.785a498b.jpg";